import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { MessageService } from '@igo2/core/message';

import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {
  private messageService = inject(MessageService);

  intercept(
    originalReq: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const interceptError = originalReq.headers.get('interceptError');
    const req = originalReq.clone({
      headers: originalReq.headers.delete('interceptError')
    });
    if (interceptError === 'false') {
      return next.handle(req);
    }
    const errorContainer = { httpError: undefined };
    return next.handle(req).pipe(
      catchError((error) => this.handleError(error, errorContainer)),
      finalize(() => {
        const httpError = errorContainer.httpError;
        if (!httpError) {
          return;
        }

        if (httpError.error.toDisplay) {
          this.handleCaughtError(httpError);
        } else if (!httpError.error.caught) {
          this.handleUncaughtError(httpError);
        }
      })
    );
  }

  private handleError(
    httpError: HttpErrorResponse,
    errorContainer: { httpError: HttpErrorResponse }
  ) {
    if (httpError instanceof HttpErrorResponse) {
      const errorObj = httpError.error === 'object' ? httpError.error : {};
      errorObj.message = httpError.error?.message || httpError.statusText;
      errorObj.caught = false;

      httpError = new HttpErrorResponse({
        error: errorObj,
        headers: httpError.headers,
        status: httpError.status,
        statusText: httpError.statusText,
        url: httpError.url
      });
    }

    errorContainer.httpError = httpError;
    return throwError(httpError);
  }

  private handleCaughtError(httpError: HttpErrorResponse) {
    httpError.error.caught = true;
    this.messageService.error(httpError.error.message, httpError.error.title, {
      progressBar: false
    });
  }

  private handleUncaughtError(httpError: HttpErrorResponse) {
    httpError.error.caught = true;
    this.messageService.error(
      'igo.core.errors.uncaught.message',
      'igo.core.errors.uncaught.title',
      {
        progressBar: false
      }
    );
  }
}
